import {useQuery} from "@tanstack/react-query";
import {readHandlerName} from "../../../../../api/main/SalesApi";

interface Props {
    teamId: string
}

export const useReadHandlerName = (param: Props) => {
    const {data} = useQuery({
        queryKey: ["readHandlerName", param],
        queryFn: async () => await readHandlerName(param),
        select: (res) => res?.data.result ?? [],
        enabled: param.teamId !== ""
    });

    return {data};
};
